export default "__VITE_ASSET__BNT29p7M__"